import axiosInstance from "../../../axios";

export const getBatchOverviewService = async (par) => {
  console.log("batchOverview Obj ", par);
  try {
    // const response = await axiosInstance.get(`/batch?id=${courseId}&pageLength=${pageLength}&pageNo=${pageNo}&batchId=${batchId}&studentName=${studentName}    `)
    const { data } = await axiosInstance.get(
      `/batch?batchId=${par.batchId}&courseId=${par.courseId}&pageLength=${9999}&pageNo=${1}`
    );
    return data;
  } catch (error) {
    console.error("Error in get batch Overview service:", error);
    throw error;
  }
};
export const deleteBatchService = async (batchId) => {
  try {
    const { data } = await axiosInstance.delete(`/batch/${batchId}`);
    return data;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};
